'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Claim API
 */
var Claim = function (_CoveAPI) {
  (0, _inherits3.default)(Claim, _CoveAPI);

  /**
   * Creates a new Claim API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Claim(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Claim);
    return (0, _possibleConstructorReturn3.default)(this, (Claim.__proto__ || (0, _getPrototypeOf2.default)(Claim)).call(this, host, 'claim/v1', environment, auth));
  }

  /**
   * Creates claim in database based on customer_id
   * @param {*} claim - Claim
   * @returns { { claim: { claim_id: string, status: string } } } - Returns claim_id and status
   */


  (0, _createClass3.default)(Claim, [{
    key: 'create',
    value: function create(claim) {
      return this.apiClient.fetch('POST', 'create', null, { claim: claim }).then(function (data) {
        return data.claim;
      });
    }

    /**
     * Retrives the claim by claim_id
     * @param {string} claim_id
     * @returns { { claim: {*} } } - Return retrieved claim object
     */

  }, {
    key: 'retrieve',
    value: function retrieve(claim_id) {
      return this.apiClient.fetch('GET', 'retrieve', { claim_id: claim_id }).then(function (data) {
        return data.claim;
      });
    }

    /**
     * Query claims by customer_id
     * @param {string} customer_id
     * @returns {[{ claim: {*} }]} - Returns list of retrieved claim objects
     */

  }, {
    key: 'queryByCustomerId',
    value: function queryByCustomerId(customer_id) {
      return this.apiClient.fetch('GET', 'query', { customer_id: customer_id }).then(function (data) {
        return data.claims;
      });
    }

    /**
     * Updates claim stored in database by merging with claim provided
     * Note you cannot update claim_id, customer_id or coverage_id
     * @param {*} claim - Claim
     * @returns { { claim: {*} } } - Returns updated claim object
     */

  }, {
    key: 'update',
    value: function update(claim) {
      return this.apiClient.fetch('POST', 'update', null, { claim: claim }).then(function (data) {
        return data.claim;
      });
    }
  }]);
  return Claim;
}(_CoveApi2.default);

exports.default = Claim;